/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_List_TitleInputs */

const en_us2_workout_list_title = /** @type {(inputs: Workout_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today's exercises`)
};

const pt_br2_workout_list_title = /** @type {(inputs: Workout_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios de hoje`)
};

const es_419_workout_list_title = /** @type {(inputs: Workout_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicios de hoy`)
};

const pt_pt2_workout_list_title = /** @type {(inputs: Workout_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios de hoje`)
};

const fr_fr2_workout_list_title = /** @type {(inputs: Workout_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercices du jour`)
};

const de_de2_workout_list_title = /** @type {(inputs: Workout_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heutige Übungen`)
};

const it_it2_workout_list_title = /** @type {(inputs: Workout_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizi di oggi`)
};

/**
* | output |
* | --- |
* | "Today's exercises" |
*
* @param {Workout_List_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_list_title = /** @type {((inputs?: Workout_List_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_List_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_list_title(inputs)
	if (locale === "es-419") return es_419_workout_list_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_list_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_list_title(inputs)
	if (locale === "de-DE") return de_de2_workout_list_title(inputs)
	if (locale === "it-IT") return it_it2_workout_list_title(inputs)
	return en_us2_workout_list_title(inputs)
});
export { workout_list_title as "workout.list_title" }